module.exports = __webpack_public_path__ + "img/secret_step_3.58c45cfb.svg";